import React from 'react';
import { Paper, Typography, Grid, Button } from '@material-ui/core';
import Page from './Page';
import IPButton from '../layout/IPButton';

const style = {
  content: {
    padding: 16,
  },
  list: {
    listStyle: 'none',
  },
  author: {
    fontSize: 'small',
    color: 'grey',
  },
  date: {
    fontSize: 'small',
    color: 'lightgrey',
  },
};

export default function Cadeaux() {
  return (
    <Page title="News BloodyBattle">
      <Paper style={style.content} square>
        <h2>Changements sur le serveur</h2>
        <ul style={style.list}>
          <li>
            <div>
              DevBlog #1 - BloodyHCF alpha v0.01 & Faction!<br />
              <span style={style.author}>NivixX</span>{' '}
              <span style={style.date}>Sun, 18 Nov 2018 14:21:50 +0000</span>
            </div>
          </li>
        </ul>
      </Paper>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/News.js